/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from "@angular/core";
import { AnalyticsService } from "./@core/utils/analytics.service";
import { TranslateService } from "@ngx-translate/core";
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterEvent } from "@angular/router";
import { FingerprintService, LoaderService } from "./services";
import { filter } from "rxjs/operators";
import * as moment from "moment";
import "moment-timezone";
import { TAG_GOOGLE } from "./app.config";

declare let gtag: Function;

moment.tz.setDefault("America/Sao_Paulo");

@Component({
    selector: "ngx-app",
    template: `
        <app-loader></app-loader>
        <router-outlet></router-outlet>
    `,
})
export class AppComponent implements OnInit {
    language: string;

    constructor(
        private analytics: AnalyticsService,
        private translate: TranslateService,
        private route: ActivatedRoute,
        private loaderService: LoaderService,
        private fingerprintService: FingerprintService,
        public router: Router
    ) {
        translate.setDefaultLang("pt");
        fingerprintService = new FingerprintService();
    }

    ngOnInit() {
        this.setUpAnalytics();

        this.language = this.route.snapshot.params.lang == null ? "pt" : this.route.snapshot.params.lang;

        this.router.events.subscribe((event: RouterEvent) => {
            if (event instanceof NavigationStart && this.router.url != "/auth/login/" + +this.language) {
                this.loaderService.show();
            }
            if (event instanceof NavigationEnd || this.router.url == "/auth/login/" + this.language) {
                this.loaderService.hide();
            }
        });
    }

    setUpAnalytics() {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            gtag("config", TAG_GOOGLE, {
                page_path: event.urlAfterRedirects,
            });
        });
    }
}
